import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import VoltBotLogo from '../../assets/VoltBotLogo.jpg';

type Props = {
  variant?: 'default' | 'compact';
};

const Logo = ({ variant = 'default' }: Props) => {
  return (
    <Box
      component={Link}
      to="/"
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        gap: 1
      }}
    >
      <Box
        component="img"
        src={VoltBotLogo}
        alt="VoltBot Logo"
        sx={{
          height: variant === 'default' ? 36 : 28,
          width: 'auto',
          borderRadius: 1
        }}
      />
      <Typography
        sx={{
          fontSize: variant === 'default' ? '1.25rem' : '1rem',
          fontWeight: 700,
          letterSpacing: '-0.5px',
          color: 'inherit'
        }}
      >
        VoltBot
      </Typography>
    </Box>
  );
};

export default Logo;
